import React from 'react';
import ReactDOM from 'react-dom/client';
import '@atlaskit/css-reset';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
